import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import AppStore from '../../../common/app-store'

const LastSell: React.FunctionComponent = () => {
    const { t } = useTranslation('landing')

    return (
        <Container>
            <Text>
                {t('last_sell.text')}
            </Text>
            <AppStore />
        </Container>
    )
}

const Container = styled.div`
    display: grid;
    justify-items: center;
    grid-gap: 16px;

    width: 100%;
    padding: 76px 0;
    color: ${p => p.theme.colors.bg};

    background: url(${require('./images/bg.png')});
    background-color: ${p => p.theme.colors.accent};
    background-size: cover;
    background-position: top center;
`

const Text = styled.div`
    font-weight: bold;
    font-size: 20px;
    line-height: 25px;
    padding: 0 30px;

    text-align: center;

    ${up('tablet')} {
        font-size: 30px;
        line-height: 38px;
    }
`

export default LastSell